import { render, staticRenderFns } from "./schematronkontrol.vue?vue&type=template&id=05305c0a&"
import script from "./schematronkontrol.vue?vue&type=script&lang=js&"
export * from "./schematronkontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports